import type { ReactNode } from 'react'
import { AppErrorState } from './AppErrorState'
import { AppLoadingState } from './AppLoadingState'
import './app-state.css'

interface AppRouteStateFrameProps {
  readonly children: ReactNode
}

interface AppRouteLoadingStateProps {
  readonly message: ReactNode
}

interface AppRouteErrorStateProps {
  readonly message: ReactNode
  readonly title?: ReactNode
}

function AppRouteStateFrame({ children }: AppRouteStateFrameProps) {
  return (
    <div className="appRouteStateFrame">
      <div className="appRouteStateContent">
        {children}
      </div>
    </div>
  )
}

export function AppRouteLoadingState({ message }: AppRouteLoadingStateProps) {
  return (
    <AppRouteStateFrame>
      <AppLoadingState message={message} />
    </AppRouteStateFrame>
  )
}

export function AppRouteErrorState({
  message,
  title,
}: AppRouteErrorStateProps) {
  return (
    <AppRouteStateFrame>
      <AppErrorState message={message} title={title} />
    </AppRouteStateFrame>
  )
}
